import { render, staticRenderFns } from "./PersonaImport.vue?vue&type=template&id=61f21472&scoped=true"
import script from "./PersonaImport.vue?vue&type=script&lang=js"
export * from "./PersonaImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f21472",
  null
  
)

export default component.exports